import service from '../axios'

// 报告在线预览地址（与小程序端保持一致）
const REPORT_PREVIEW_BASE_URL = 'https://t.zysjkxjc.com/report'

// 浏览器本地缓存的报告查询记录 key
export const REPORT_RECORDS_STORAGE_KEY = 'jingkexin_report_records'
// 本地缓存记录上限
export const REPORT_RECORDS_MAX = 50

export const reportApi = {
  // 查询检测报告（检品编号+委托单位+报告预留联系电话，三项均正确方可查询，需先完成行为验证码校验）
  queryReport(data) {
    return service.post('/www/api/lims/queryReport', {
      clientType: 'WWW',
      ...data
    })
  },

  // 获取行为验证码接口地址（供 TAC SDK 使用）
  captchaUrls() {
    const base = String(service.defaults.baseURL || '').trim().replace(/\/+$/, '')
    return {
      requestCaptchaDataUrl: `${base}/captcha/gen`,
      validCaptchaUrl: `${base}/captcha/check`
    }
  },

  // 构建报告在线预览地址
  buildReportPreviewUrl(reportId) {
    const id = String(reportId || '').trim()
    if (!id) return ''
    return `${REPORT_PREVIEW_BASE_URL}?c=${encodeURIComponent(id)}`
  },

  // 读取浏览器本地缓存的报告查询记录
  getRecords() {
    try {
      const raw = window.localStorage.getItem(REPORT_RECORDS_STORAGE_KEY)
      const list = raw ? JSON.parse(raw) : []
      return Array.isArray(list) ? list : []
    } catch (e) {
      return []
    }
  },

  // 缓存一条报告查询记录（按报告编号去重，最新在前，超出上限丢弃旧记录）
  saveRecord(record) {
    const list = this.getRecords().filter(item => item.reportId !== record.reportId)
    list.unshift(record)
    try {
      window.localStorage.setItem(
        REPORT_RECORDS_STORAGE_KEY,
        JSON.stringify(list.slice(0, REPORT_RECORDS_MAX))
      )
    } catch (e) {
      // 存储失败时忽略（如隐私模式/空间不足）
    }
    return list.slice(0, REPORT_RECORDS_MAX)
  },

  // 清空浏览器本地缓存的报告查询记录
  clearRecords() {
    try {
      window.localStorage.removeItem(REPORT_RECORDS_STORAGE_KEY)
    } catch (e) {
      // 忽略
    }
  }
}
